<template>
  <div>
    <div class="row">
      <div class="col" style="max-width:1400px">
        <div class="d-flex align-items-center justify-content-between border-bottom mb-4 pb-2">
          <div>
            <h3 class="mb-0">{{ projectStore.activeProject.Name }}</h3>
          </div>
          <div>
            <transition name="fade">
              <div>
                <span
                  class="bg-danger border border-danger text-white pl-3 pr-2 py-1 "
                  style="border-top-left-radius: 1rem; border-bottom-left-radius: 1rem;  "
                  v-if="projectStore.activeProject.IsDemo"
                >
                  DEMO-PROJEKT
                </span>

                <a
                  class="bg-white border border-danger text-danger px-3 py-1"
                  id="become-customer-btn"
                  v-if="projectStore.activeProject.IsDemo"
                  role="button"
                  @click="becomeCustomer"
                  title="Einen BauVisor Mitarbeiter informieren, um weitere Informationen zu erhalten."
                >
                  Jetzt Kunde werden!
                </a>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <!-- Banner, das Projekt archiviert ist  -->
    <div class="row" v-if="projectStore.activeProject.State == CONSTANTS.PROJECT_STATES.ARCHIVIERT">
      <div class="col" style="max-width:1400px">
        <b-alert :show="projectStore.activeProject.State == 2" variant="info">
          <b-icon scale="1.3" class="mr-2" icon="info-circle" />
          Projekt ist archiviert und kann nicht mehr bearbeitet werden.
        </b-alert>
      </div>
    </div>
    <div class="row">
      <!-- Projektattribute und Bild -->
      <div class="col-4">
        <div class="border bg-white pb-3 mb-2" s>
          <label v-if="$root.$user.isPlaner || this.$root.$user.isAdmin" class="pl-2 pt-1">
            <small class="text-muted">Projektbild (max. 2MB)</small>
          </label>
          <div class="d-flex h-100 justify-content-center align-items-center">
            <img
              :role="$root.$user.isPlaner || this.$root.$user.isAdmin ? 'button' : ''"
              :src="projectStore.currentProjectPicture"
              class="uploading-image "
              title="Klicken, um neues Bild hochzuladen."
              v-if="projectStore.currentProjectPicture && !projectStore.isPictureLoading"
              @click="openFileDialog"
            />
            <div
              class="text-center text-grey p-5"
              v-if="
                !projectStore.currentProjectPicture &&
                  projectStore.activeProject.State > CONSTANTS.PROJECT_STATES.AUSFUEHRUNG
              "
            >
              Kein Bild vorhanden
            </div>
            <div
              :role="$root.$user.isPlaner || this.$root.$user.isAdmin ? 'button' : ''"
              v-if="
                !projectStore.currentProjectPicture &&
                  !projectStore.isPictureLoading &&
                  ($root.$user.isPlaner || this.$root.$user.isAdmin)
              "
              class="text-center text-grey border p-5"
              @click="openFileDialog"
            >
              Klicken, um Projektbild hochladen...
            </div>
            <div
              style="height: 300px"
              :class="{
                'text-center text-grey border p-5': true,
                'd-flex justify-content-center mb-3 loading-spinner-wrapper': isPictureLoading,
                'd-none': !isPictureLoading
              }"
              class=" "
            >
              <b-spinner variant="primary" label="Loading..."></b-spinner>
            </div>
          </div>
        </div>
        <label><small class="text-muted">Projektbezeichnung</small></label>
        <b-input
          v-model.lazy="projectRecord.Name"
          @change="updateProject"
          :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
        />
        <label class="mt-3"><small class="text-muted">Projektnummer</small></label>
        <b-input
          v-model.lazy="projectRecord.ProjectIdentifier"
          @change="updateProject"
          :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
        />
        <label class="mt-3"><small class="text-muted">Projektleiter (intern)</small></label>
        <b-input
          v-model.lazy="projectRecord.ProjectLeadInternal"
          @change="updateProject"
          :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
        />
        <label class="mt-3"><small class="text-muted">Auftraggeber</small></label>
        <b-input
          v-model.lazy="projectRecord.CustomerText"
          @change="updateProject"
          :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
        />
        <label class="mt-3"><small class="text-muted">Projektleiter (Auftraggeber)</small></label>
        <b-input
          v-model.lazy="projectRecord.ProjectLeadExternal"
          @change="updateProject"
          :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
        />
        <label class="mt-3"><small class="text-muted">Projektstart</small></label>
        <b-input
          v-model.lazy="projectRecord.ProjectStartDate"
          @change="updateProject"
          type="date"
          min="2000-01-01"
          max="2099-12-31"
          readonly
          disabled
        />
        <input
          type="file"
          class="d-none"
          accept=".png, .jpg, .jpeg"
          placeholder="Datei wählen..."
          drop-placeholder="Drop file here..."
          @change="uploadImage"
          ref="fileInput"
        />
      </div>
      <!-- Dashboard Widgets -->
      <div class="col-8" v-if="$root.$user.isSuperAdmin"><DashboardLine /></div>
    </div>
  </div>
</template>

<script>
import projectStore from '@/store/Projects';
import projectService from '@/service/ProjectsService';
import userService from '@/service/UserService';
import AppState from '@/store/App.js';
//import ProjectService from '../../../backend/service/ProjectService';

export default {
  components: {
    DashboardLine: () => import('@/components/settings/DashboardLine.vue')
  },
  data() {
    return {
      projectStore,
      projectRecord: {},
      projectPicturePreview: null,
      isPictureLoading: false,
      isEndRequestCanceled: false
    };
  },
  methods: {
    updateProject() {
      projectService
        .update(this.projectRecord)
        .then(() => {
          this.$showSuccess(this, 'Einstellungen', 'Einstellungen erfolgreich aktualisiert.');
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        });

      projectStore.activeProject = { ...this.projectRecord };
      const project = projectStore.projects.find(x => x.DbId == this.projectRecord.DbId);
      project.Name = this.projectRecord.Name;
      project.ProjectIdentifier = this.projectRecord.ProjectIdentifier;
      project.ProjectLeadInternal = this.projectRecord.ProjectLeadInternal;
      project.ProjectLeadExternal = this.projectRecord.ProjectLeadExternal;
      project.CustomerText = this.projectRecord.CustomerText;
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e => {
        this.projectRecord.ProjectPicture = e.target.result;
        this.projectPicturePreview = e.target.result;
        projectService.updateProjectPicture(this.projectRecord.ProjectPicture).then(() => {
          this.$showSuccess(this, 'Einstellungen', 'Projektbild erfolgreich aktualisiert.');
        });
      };
    },
    openFileDialog() {
      if (!(this.$root.$user.isPlaner || this.$root.$user.isAdmin)) return;
      this.$refs.fileInput.click();
    },
    loadProjectPicture() {
      //console.log('zzz projectStore.activeProject.ProjectPicture', projectStore.activeProject.ProjectPicture);
      this.projectPicturePreview = projectStore.activeProject.ProjectPicture;
      /*
      console.log('Zzzz load the picture!');
      if (projectStore.activeProject.ProjectPicture) {
        this.projectPicturePreview = projectStore.activeProject.ProjectPicture;
        projectStore.currentProjectPicture = this.projectPicturePreview;
      } else {
        this.isPictureLoading = true;
        projectService
          .getProjectPicture()
          .then(picture => {
            if (picture) {
              this.projectPicturePreview = Buffer.from(picture).toString();
              projectStore.activeProject.ProjectPicture = this.projectPicturePreview;
              projectStore.currentProjectPicture = this.projectPicturePreview;
            } else projectStore.currentProjectPicture = null;
            this.isPictureLoading = false;
          })
          .catch(err => console.log(err));
        this.projectPicturePreview = null;
      }*/
    },
    cancelProjectEndRequest() {
      this.$bvModal
        .msgBoxConfirm('Soll der Antrag auf Löschung des Projekts widerrufen werden?', {
          title: 'Projektlöschung abbrechen',
          okTitle: 'Widerrufen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(async confirmed => {
          if (confirmed) {
            projectService
              .abortEnd()
              .then(() => {
                projectStore.activeProject.HasEndRequests = null;
                this.isEndRequestCanceled = true;
                this.$showSuccess(
                  this,
                  'Projekt beenden',
                  'Der Löschantrag für das Projekt "' +
                    projectStore.activeProject.Name +
                    '" wurde erfolgreich widerrufen.'
                );
              })
              .catch(err => this.$showError(this, JSON.stringify(err)));
          }
        });
    },
    async becomeCustomer() {
      if (projectStore.activeProject && projectStore.activeProject.IsDemo !== true) {
        // show error message box
        return;
      }
      await userService.becomeCustomer();

      this.$bvModal.msgBoxOk(
        'Vielen Dank für Interesse. Bezüglich der rahmenvertraglichen Vereinbarungen wird sich in Kürze ein Mitarbeiter von BauVisor bei Ihnen melden.',
        {
          title: 'Demo Projekt - Kunde werden',
          //okVariant: 'danger',
          //headerTextVariant: 'danger',
          centered: true
        }
      );
    }
  },
  activated() {
    this.projectRecord = { ...projectStore.activeProject };
    //this.loadProjectPicture();
    AppState.isLoading = false;
  },

  mounted() {
    //console.log('zzz mounted registering projectSwitched', projectStore.activeProject);
    this.$eventBus.$on('projectSwitched', () => {
      //console.log('zzz handling projectSwitched', projectStore.activeProject);
      this.projectRecord = { ...projectStore.activeProject };
      this.loadProjectPicture();
    });
  }
};
</script>

<style scoped>
.uploading-image {
  display: flex;
  max-width: 100%;
  max-height: calc(100vh - 470px);

  /* border: 1px solid #dee2e6; */
}

#become-customer-btn {
  border-top-right-radius: 1rem;
  border-bottom-right-radius: 1rem;
}

#become-customer-btn:hover {
  background-color: color-mix(in srgb, var(--danger), #fff 95%) !important;
  color: color-mix(in srgb, var(--danger), #000 25%) !important;
  border-color: color-mix(in srgb, var(--danger), #000 25%) !important;
}
</style>
